///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = {
    init: function () {
        //alert(JSON.stringify(abcsetup.userRole.class));
        abcsetup.setTitle('Dashboard');

        // Expand panel click
        $(document).on('click', '.panel a.expand', function () {
            var panel = $(this).closest('.panel');

            panel.toggleClass('expanded');
            $('body').toggleClass('expanded');
            $(this).children('i').toggleClass('fa-expand').toggleClass('fa-compress');

            // Trigger the resize event for any datatables
            panel.find('table.datatable').trigger('resize');

            // Reload the expanded/collapsed panel
            //abcsetup.dashboard.loadPanel(panel.find('a.list-group-item.active'));

            return false;
        });

        // Panel verticle tab clicked
        $("div.bhoechie-tab-menu > div.list-group > a").click(function (e) {
            e.preventDefault();
            $(this).siblings('a.active').removeClass("active");
            $(this).addClass("active");

            var index = $(this).index();
            var panel = $(this).closest('div.panel');

            panel.find("div.bhoechie-tab > div.bhoechie-tab-content").removeClass("active");
            panel.find("div.bhoechie-tab > div.bhoechie-tab-content").eq(index).addClass("active");

            // Load a panel contents by button clicked
            abcsetup.dashboard.loadPanel($(this));

            // Store the selected panel in session stoage
            sessionStorage.setItem('dashboard_panel_' + $(this).closest('.panel').attr('id'), $(this).index());

            // Trigger the resize event for any datatables
            panel.find('table.datatable').trigger('resize');

            // Load any deferred datatables
            panel.find("div.bhoechie-tab > div.bhoechie-tab-content").eq(index).find('table.datatable').each(function () {
                abcsetup.datatables.yajra.loadDeferredTable($(this));
            });

            return false;
        });

        // Panel toggle group button clicked - set a session storage value for the selected radio button
        $(document).on('change', '.bhoechie-tab-content .btn-group-toggle input:radio', function () {
            sessionStorage.setItem('dashboard_toggle_' + $(this).attr('name'), $(this).val());

            // Load any deferred datatables
            $(this).closest('.bhoechie-tab').find('table.datatable').each(function () {
                abcsetup.datatables.yajra.loadDeferredTable($(this));
            });
        });

        // Set the default values for the toggle group buttons
        abcsetup.dashboard.setDefaultToggles();

        // Init role specific dashboard
        abcsetup.dashboard.initRoleDashboard();

        // Init all panels
        $("div.bhoechie-tab-menu").each(function () {
            // Load a panel contents by button clicked
            abcsetup.dashboard.loadPanel($(this).find('a:first'));
            //$(this).find('a:first').trigger('click');

            // Set the default left hand nav panel for the specified panel
            abcsetup.dashboard.setDefaultPanel($(this).closest('.panel'));
        });
    },


    /**
     * Set the default values for the toggle group buttons
     */
    setDefaultToggles: function () {
        $('.bhoechie-tab-content .btn-group-toggle').each(function () {
            const name = $(this).find('input:radio:first').attr('name');
            const val = sessionStorage.getItem('dashboard_toggle_' + name);

            if (val) {
                $(this).find('label').removeClass('active');
                $(this).find('[name=' + name + '][value=' + val + ']').attr('checked', true).closest('label').addClass('active');
            }
        });
    },


    /**
     * Set the default left hand nav panel for the specified panel
     */
    setDefaultPanel: function (panel) {
        var val = sessionStorage.getItem('dashboard_panel_' + panel.attr('id'));

        if (val) {
            panel.find('div.bhoechie-tab-menu a:eq(' + val + ')').trigger('click');
        }

        // Show all the left hand nav panels for the panel
        panel.find('div.bhoechie-tab-menu a').show();
    },


    /**
     * Init role specific dashboard
     */
    initRoleDashboard: function (funcName = 'init', callBack = null) {
        var dashboard = abcsetup.userRole ? abcsetup.userRole.class : '';

        if (dashboard) {
            // Format role class name
            if (dashboard == 'gsmd_team') {
                dashboard = 'gsmd';
            }

            console.log('Init route JS: window.abcsetup.dashboard.' + dashboard);
            eval('if (window.abcsetup.dashboard.' + dashboard + ' && window.abcsetup.dashboard.' + dashboard + '.' + funcName + ') { window.abcsetup.dashboard.' + dashboard + '.' + funcName + '("' + callBack + '"); }');
        }
    },

    tableDrawCallback: function(table) {
        this.initRoleDashboard('tableDrawCallback', table);
    },

    /**
     * Load a panel contents by button clicked
     */
    loadPanel: function (button) {
        const panel = button.closest('.panel');
        abcsetup.dashboard.removeDynamicBreadcrumbs(panel);

        if (button.attr('title')) {
            let target_panel = panel.find('.bhoechie-tab-content.active');

            if (target_panel.find('.content').length) {
                target_panel = target_panel.find('.content');
            }

            abcsetup.dashboard.addBreadcrumb(panel, null, button.attr('title'));
            const addTitleToPanel = () => {
                if (target_panel.find('h5.panel-title').length === 0) {
                    target_panel.prepend('<h5 class="panel-title mb-3">' + button.attr('title') + '</h5>');
                }
            };
            addTitleToPanel();

            // We have specified an ajax function
            if (button.data('function')) {
                if (button.data('ajax') !== false) {
                    abcsetup.dashboard.showLoading(panel);
                    target_panel.empty();
                    addTitleToPanel();
                }

                eval(button.data('function'));
            }
        }
    },


    /**
     *
     */
    showLoading: function (panel) {
        panel.find('li.loading').remove();
        panel.find('.breadcrumb').append('<li class="loading"><img src="/img/loading.gif"></li>');
    },


    /**
     *
     */
    removeLoading: function (panel = null) {
        if (panel !== null) {
            panel.find('li.loading').remove();
        } else {
            $('li.loading').remove();
        }
    },


    /**
     * Add a breadcrumb to the specified panel with the specified backfuncion
     */
    addBreadcrumb: function (panel, backfunc, newtext) {
        var currentText = panel.find('.breadcrumb li.active').html();

        if (backfunc !== null) {
            panel.find('.breadcrumb li.active').removeClass('active').html('<a href="#" onclick="' + backfunc + '">' + currentText + '</a>');
        }

        panel.find('.breadcrumb').append('<li class="active dynamic">' + newtext + '</li>');
    },


    /**
     * Format and set the badge value
     *
     * @param {*} badge
     * @param {*} value
     */
    setBadge: function (badge, value) {
        if (value > 0) {
            if (value < 10) {
                value = '&nbsp;' + value + '&nbsp;';
            }

            badge.html(value);

        } else {
            badge.empty();
        }
    },


    /**
     *
     */
    removeDynamicBreadcrumbs: function (panel) {
        panel.find('.breadcrumb li.dynamic').remove();
        panel.find('.breadcrumb li.active').removeClass('active');
        //alert(panel.find('.breadcrumb li').length);
        //panel.find('.breadcrumb li:last').addClass('active');

        var activeCrumb = panel.find('.breadcrumb li.active');
        activeCrumb.html(activeCrumb.text());
    },
}
